import TiptapViewer from './TiptapViewer'
import { withTiptapViewer } from './withTiptapViewer'

const ConnectedTiptapViewer = withTiptapViewer(TiptapViewer)

export { ConnectedTiptapViewer as TiptapViewer }
